export default function(StringText){
    const regex= new RegExp('([+]\\d{1,2})(\\d{10})')
    if(regex.test(StringText)!==true) return false
    else return true
}
